export default __webpack_public_path__ + "static/media/purgo_logo_black.61d018b8.png";